
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://qhqpqkkjsqgaklauknnr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFocXBxa2tqc3FnYWtsYXVrbm5yIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzgyNjY4ODIsImV4cCI6MjA1Mzg0Mjg4Mn0.nHBLSJckle8r_SDU1qJKI_-dbpxcqsW6FFCuaeNzPk0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    debug: true // Enable debug mode to help troubleshoot auth issues
  }
});
